import React, {useContext, useEffect, useState} from 'react';
import {WMSContext} from "../context/WMSContext";
import CreatePickingMissionDesktopContainer from "./Desktop/CreatePickingMissionDesktopContainer";
import CreatePickingMissionMobileContainer from "./Mobile/CreatePickingMissionMobileContainer";
import {creationData} from "../../../api/wms/tasks/new";
import {useParams} from "react-router-dom";
import {getWMSPickingMissionModel} from "../../../api/wms/wmsTaskModel/list";
import {PickingMissionModelContext} from "./PickingMissionModelContext";

function Index() {
    const {currentInventory, isMobile} = useContext(WMSContext)

    const [data, setData] = useState()
    const [editableModel, setEditableModel] = useState()
    const [isEdit, setIsEdit] = useState(false)
    const [isModel, setIsModel] = useState(false)
    const [isModelAuto, setIsModelAuto] = useState(false)

    const { modelId } = useParams()

    const init = () => {
        creationData(currentInventory.id).then(response => {
            setData(response)
        })

        if (!modelId && currentInventory) {
            setIsEdit(false)
        }

        if (modelId) {
            getWMSPickingMissionModel(modelId).then(response => {
                setEditableModel(response)
                setIsModel(true)
                setIsModelAuto(response.auto)
                setIsEdit(true)
            })
        }
    }

    useEffect(() => {
        if (currentInventory) {
            init()
        }
    }, [modelId, currentInventory]);

    return (
        <PickingMissionModelContext.Provider value={{
            isEdit: isEdit,
            editableModel: editableModel,
            data: data,
            isModel: isModel,
            isModelAuto: isModelAuto,
            isMobile: isMobile,
            setIsModelAuto: setIsModelAuto,
            setIsModel,
            init: init
        }}>
            {data && isMobile === true && (
                <CreatePickingMissionMobileContainer />
            )}

            {data && isMobile === false && (
                <CreatePickingMissionDesktopContainer />
            )}


        </PickingMissionModelContext.Provider>
    );
}

export default Index;